import {
  API_GET_ACH_FORM_RESPONSES,
  API_GET_ACH_REPORT_DETAILS,
  API_GET_DASHBOARD_ACH_DAY_REPORT_STATUS_STORE_WISE,
  API_POST_APPROVE_ACH_REPORT,
  API_POST_UPDATE_ACH_FORM_DATA,
} from 'common/constants/apis';
import { CRASHLYTICS_API_ERROR } from 'common/constants/errors';
import UILogger, { LogRecordType, LogSeverityType } from 'common/utils/logger';
import httpClient from './config';
import { IDayReportEntryUpdateResp, IReopenDayReportResponse } from 'common/interfaces/iDayReports';
import { DEFAULT_RETRY_CONFIG } from 'common/constants';
import { AxiosRequestConfig } from 'axios';
import {
  IACHFormEntryUpdateResp,
  IACHFormResponse,
  IACHFormResponsesPagedDataResponse,
  IACHReportDetailsResp,
  IRoyaltyReportsPagedDataResponse,
  IRoyaltyReportsResponse,
} from 'common/interfaces/iRoyaltyReports';

export const getRoyaltyReportsForStore = async (
  storeId: number,
  startDate: string,
  endDate: string,
  pageNo: number,
  pageSize: number,
): Promise<IRoyaltyReportsPagedDataResponse> => {
  UILogger.log('RoyaltyReportService: Getting royalty reports:', storeId, startDate, endDate, pageNo, pageSize);

  const url = API_GET_DASHBOARD_ACH_DAY_REPORT_STATUS_STORE_WISE.replace('{storeId}', storeId.toString())
    .replace('{startDate}', startDate)
    .replace('{endDate}', endDate)
    .replace('{pageNo}', pageNo.toString())
    .replace('{pageSize}', pageSize.toString());
  return httpClient
    .get(url)
    .then((res) => {
      UILogger.log('RoyaltyReportService: response, ', res.data);
      if (res.status === 200) {
        return res.data;
      }
      return { status: { success: false } } as IRoyaltyReportsPagedDataResponse;
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        UILogger.log(
          {
            recordType: LogRecordType.CRASHLYTICS,
            severity: LogSeverityType.ERROR,
            error,
            tag: CRASHLYTICS_API_ERROR,
          },
          'RoyaltyReportService: Error in getting draft day report',
          error,
        );
      }
      UILogger.log('RoyaltyReportService: Error in getting draft day report', error?.response?.status);
      return { status: { success: false } } as IRoyaltyReportsPagedDataResponse;
    });
};

export function postUpdateACHFormEntry(formId: number, payload: IACHFormResponse): Promise<IACHFormEntryUpdateResp> {
  UILogger.info('postUpdateACHFormEntry: Sending update request', payload, ',formId:', formId);
  let url = API_POST_UPDATE_ACH_FORM_DATA;

  url = url.replace('{formId}', formId.toString());

  return httpClient
    .post(url, payload, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then((res) => {
      UILogger.log('UPDATE form entry response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      console.log('Error upserting form entry:::', error.response.data);
      return error.response.data;
    });
}

export function getACHFormResponses(reportId: number): Promise<IACHFormResponsesPagedDataResponse> {
  UILogger.info('getACHFormResponses: reportId:', reportId);
  let url = API_GET_ACH_FORM_RESPONSES;

  url = url?.replace('{reportId}', reportId.toString());
  UILogger.info('getACHFormResponses: Sending get forms url:', url);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then((res) => {
      UILogger.log('GET ach forms response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      console.log('Error in getting ach forms responses:::', error.response.data);
      return error.response.data;
    });
}

export function getACHReportDetails(reportId: number): Promise<IACHReportDetailsResp> {
  UILogger.info('getACHReportDetails: reportId:', reportId);
  let url = API_GET_ACH_REPORT_DETAILS;

  url = url?.replace('{reportId}', reportId.toString());
  UILogger.info('getACHReportDetails: Sending get report details:', url);
  return httpClient
    .get(url, DEFAULT_RETRY_CONFIG as AxiosRequestConfig)
    .then((res) => {
      UILogger.log('GET ach forms response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      console.log('Error in getting ach forms responses:::', error.response.data);
      return error.response.data;
    });
}

export const postRoyaltyReportApproval = (reportId: number): Promise<IReopenDayReportResponse> => {
  UILogger.info('postRoyaltyReportApproval: ', reportId);
  return httpClient
    .get(API_POST_APPROVE_ACH_REPORT.replace('{reportId}', reportId.toString()))
    .then((res) => {
      UILogger.log('v response: ', res.data);
      return res.data;
    })
    .catch((error) => {
      console.log('Error in postRoyaltyReportApproval:::', error.response.data);
      return error.response.data;
    });
};
